import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 100,
    },
  ];

  return { Table };
};

export default configTable;
